module.exports = __webpack_public_path__ + "img/hyl_theMall.4a1cf5b2.png";